import { createStore, applyMiddleware, compose } from 'redux';
import { logger } from 'redux-logger';

import reducer from './../reducers/app';

//TODO: This is for DEV only and should be removed once we deploy to prod
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: typeof compose;
    store: object;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Configure middleware used by redux
const middlewares = [];

if(process.env.REACT_APP_ENVIRONMENT === 'Production') {}
else{middlewares.push(logger)};

const store = createStore(reducer, composeEnhancers(applyMiddleware(...middlewares)));

window.store = store;

export default store;
